import * as React from "react"
import { cn } from "@/lib/utils"

// Radio Group nativo - evita bugs do Radix UI em iOS/Safari
const NativeRadioGroup = React.forwardRef(({ className, value, onValueChange, children, ...props }, ref) => {
  return (
    <div 
      ref={ref}
      role="radiogroup"
      className={cn("grid gap-2", className)} 
      {...props}
    >
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            checked: child.props.value === value,
            onChange: () => onValueChange?.(child.props.value),
          });
        }
        return child;
      })}
    </div>
  );
})
NativeRadioGroup.displayName = "NativeRadioGroup"

const NativeRadioGroupItem = React.forwardRef(({ className, value, checked, onChange, children, ...props }, ref) => {
  return (
    <div className="flex items-center space-x-2">
      <input
        ref={ref}
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
        className={cn(
          "h-4 w-4 rounded-full border border-[#8F7AC5] text-[#8F7AC5] focus:ring-2 focus:ring-[#8F7AC5] focus:ring-offset-2 cursor-pointer",
          className
        )}
        {...props}
      />
      {children}
    </div>
  );
})
NativeRadioGroupItem.displayName = "NativeRadioGroupItem"

export { NativeRadioGroup, NativeRadioGroupItem }
